import { restoreGamePortalReturnLocation } from "../game-portal-resume";
import { getSelectedRuntimeEndpoint, initializeRuntimeEndpoints } from "./runtime-endpoints";

export interface GameRuntimeConfig {
  apiBaseUrl: string;
  forumBaseUrl: string;
  packageId: number;
  defaultModelId?: number;
  appId?: string;
}

const DEFAULT_FORUM_BASE_URL = "https://www.ggmnq.com";

function apiBaseUrlFromSiteBaseUrl(siteBaseUrl: string) {
  return `${new URL(siteBaseUrl).origin}/api`;
}

let runtimeConfig: GameRuntimeConfig = {
  apiBaseUrl: apiBaseUrlFromSiteBaseUrl(DEFAULT_FORUM_BASE_URL),
  forumBaseUrl: DEFAULT_FORUM_BASE_URL,
  packageId: 0
};

function readEnv(name: string) {
  const env = (import.meta as ImportMeta & { env: Record<string, string | undefined> }).env;
  if (name === "VITE_FORUM_BASE_URL") return env.VITE_FORUM_BASE_URL;
  if (name === "VITE_LLM_MODEL_ID") return env.VITE_LLM_MODEL_ID;
  return undefined;
}

export function configureGameRuntime(config: Partial<GameRuntimeConfig> & Pick<GameRuntimeConfig, "packageId">) {
  const envModelId = Number(readEnv("VITE_LLM_MODEL_ID"));
  const forumBaseUrl = (config.forumBaseUrl || readEnv("VITE_FORUM_BASE_URL") || DEFAULT_FORUM_BASE_URL).replace(/\/$/, "");
  runtimeConfig = {
    // 生产入口只配置站点域名；显式 apiBaseUrl 仅供隔离测试或本机服务覆盖。
    apiBaseUrl: (config.apiBaseUrl || apiBaseUrlFromSiteBaseUrl(forumBaseUrl)).replace(/\/$/, ""),
    forumBaseUrl,
    packageId: config.packageId,
    // model_id 与 package/category ID 无关。未配置时由模型列表选择首个可调用模型。
    defaultModelId: config.defaultModelId ?? (Number.isInteger(envModelId) && envModelId > 0 ? envModelId : undefined),
    appId: config.appId
  };
  initializeRuntimeEndpoints({
    apiOrigin: runtimeConfig.apiBaseUrl,
    forumOrigin: runtimeConfig.forumBaseUrl
  });
  restoreGamePortalReturnLocation(runtimeConfig.packageId);
}

export function getGameRuntimeConfig() {
  if (!runtimeConfig.packageId) {
    throw new Error("Game runtime is not configured. Call configureGameRuntime before using API clients.");
  }

  // 域名选举在后台更新，所有消费者读取配置时都取得最新结果，避免组件保存过期 origin。
  return {
    ...runtimeConfig,
    apiBaseUrl: getSelectedRuntimeEndpoint("api"),
    forumBaseUrl: getSelectedRuntimeEndpoint("forum")
  };
}
